import debounce from './debounce';
import { updateStripePaymentRequestButton } from './payments/stripe/payment-button';
import { emailRegex } from './utils';

const isPlanAnOffer = (selectedPlan) => {
  const todaysTotalPrice = selectedPlan.dataset.todaysTotal;
  const selectedOriginalPrice = selectedPlan.dataset.originalPrice;
  if (todaysTotalPrice && selectedOriginalPrice) {
    const todaysTotalPriceNum = parseFloat(todaysTotalPrice.replace('$', ''));
    const selectedOriginalPriceNum = parseFloat(selectedOriginalPrice.replace('$', ''));
    return todaysTotalPriceNum < selectedOriginalPriceNum;
  }
};

const showAndUpdatePrice = (selectedPlan) => {
  const selectedPlanDataId = selectedPlan.dataset.planId;
  const todaysTotalPrice = selectedPlan.dataset.todaysTotal;
  const priceContainerEl = document.querySelector('#post-offer-price-container');
  if (isPlanAnOffer(selectedPlan)) {
    const todaysTotalPriceNum = parseFloat(todaysTotalPrice.replace('$', ''));
    priceContainerEl.classList.remove('hidden');
    updateStripePaymentRequestButton({
      amount: todaysTotalPriceNum * 100,
      label: 'Subscription to The Information',
    });
  } else {
    priceContainerEl.classList.add('hidden');
    updateStripePaymentRequestButton(selectedPlanDataId);
  }
};

const updatePostOfferPrice = (selectedPlan) => {
  const selectedFrequency = selectedPlan.dataset.frequency;
  const selectedOriginalPrice = selectedPlan.dataset.originalPrice;
  // Update the "Today's Total" based on the plan
  const todaysTotalPrice = selectedPlan.dataset.todaysTotal;
  document.querySelector('#subscribe-todays-total-price').innerHTML = todaysTotalPrice;
  // Update the frequency and original price based on the plan
  document.querySelector(
    '#post-offer-frequency'
  ).innerHTML = `${selectedFrequency} after the offer concludes`;
  document.querySelector('#post-offer-original-price').innerHTML = selectedOriginalPrice;
};

export const clickOnPlan = (plans, selectedPlan) => {
  plans.forEach((p) => p.classList.remove('selected'));

  // Find data planId of the plan that was clicked on
  // Find all element with that planId add selected class to them.
  const selectedPlanDataId = selectedPlan.dataset.planId;
  const allSelectedPlans = document.querySelectorAll(`div[data-plan-id="${selectedPlanDataId}"]`); // All plans, both desktop and mobile, sharing selectedPlan's data-plan-id
  allSelectedPlans.forEach((p) => p.classList.add('selected'));

  if (['yp199', 'yp225'].includes(selectedPlanDataId)) {
    document
      .querySelectorAll('.show-for-yp')
      .forEach((element) => element.classList.remove('hidden'));
    validateDOB(); // this should initially always be invalid for an empty form
  } else {
    // hide the birthday form and error and recheck to see if payment form should be disabled
    $('.show-for-yp').addClass('hidden');
    $('#dob-error').addClass('hidden');
  }

  updateShowPaymentForm();
  updatePostOfferPrice(selectedPlan);
  showAndUpdatePrice(selectedPlan);
};

export const setupUserInfoValidation = function () {
  [
    { selector: '.account-name', validator: (val) => Boolean(val.match(/^[^ ]+( [^ ]+)+$/)) },
    { selector: '.account-email', validator: (val) => Boolean(val.match(emailRegex)) },
    { selector: '.account-password', validator: (val) => val.length >= 6 },
  ].forEach((obj) => {
    const field = document.querySelector(obj.selector);
    if (field) {
      field.addEventListener('blur', () => {
        if (obj.validator(field.value)) {
          field.nextElementSibling.classList.add('hidden');
        } else {
          field.nextElementSibling.classList.remove('hidden');
        }
      });
    }
  });

  const accountInfoForm = document.querySelector('.signup-form');
  accountInfoForm.addEventListener(
    'focusout',
    debounce(() => updateShowPaymentForm(), 300)
  );
};

const isAccountInfoComplete = () => {
  return (
    document.querySelector('.account-name').value &&
    document.querySelector('.account-email').value &&
    (!document.querySelector('.account-password') || // password field is not always present
      document.querySelector('.account-password').value) &&
    true
  );
};

// Disable the payment section if any client side validation issues
export const updateShowPaymentForm = (forceDisable = false) => {
  const errors = [...document.querySelectorAll('.subscribe-account-info-error')],
    hasErrors = errors
      .map((error) => !error.classList.contains('hidden'))
      .reduce((prev, cur) => prev || cur),
    paymentForm = document.querySelector('.tabbed-payment-ui');
  hasErrors || forceDisable || !isAccountInfoComplete()
    ? paymentForm.classList.add('disabled')
    : paymentForm.classList.remove('disabled');
};

// check email to see if user is a past or canceled subscriber
export const checkForSubscription = async (e) => {
  // Don't check if the field changed isn't one of the account information fields
  if (!e.target.closest('.account-info')) {
    return;
  }
  const form = document.querySelector('.signup-form'),
    emailField = form.querySelector('.account-email'),
    email = emailField.value;
  // Don't do anything if the email field is hidden, i.e. wrapped inside a container with display: none
  if (emailField.offsetWidth == 0 && emailField.offsetHeight == 0) {
    return;
  }
  // Don't bother checking with the server if the email is obviously invalid
  if (!email.match(emailRegex)) {
    return;
  }
  form.removeEventListener('change', debounce(checkForSubscription, 300));
  const csrfToken = document.querySelector('[name="csrf-token"]'),
    headers = new Headers({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken ? csrfToken.content : 'DEFAULT_CSRF', // Provide a fallback for Selenium
    }),
    payload = {
      headers: headers,
      credentials: 'same-origin',
      method: 'POST',
      body: JSON.stringify({ email: email, redirectUri: emailField.dataset.redirectUri }), // redirectUri could be null, that's fine
    },
    request = new Request(emailField.dataset.validateUri, payload);
  try {
    const response = await fetch(request);
    if (!response.ok) {
      throw new Error(response.statusText);
    }
    const responseBody = await response.json(),
      redirectFieldsContainer = document.getElementById('subscribe-redirect-container');
    if (responseBody.action == 'show_payment_form') {
      // if redirect container is not already hidden, hide it
      if (!redirectFieldsContainer.classList.contains('hidden')) {
        redirectFieldsContainer.classList.add('hidden');
      }
    } else if (responseBody.action == 'show_button') {
      const btn = redirectFieldsContainer.querySelector('.button-submit'),
        text = redirectFieldsContainer.querySelector('.helper-text');
      // Add the right copy/functionality to the form first
      btn.href = responseBody.action_href;
      btn.innerHTML = responseBody.action_text;
      text.innerHTML = responseBody.action_helper_text;
      if (redirectFieldsContainer.classList.contains('hidden')) {
        // if redirect container is hidden, show it
        redirectFieldsContainer.classList.remove('hidden');
      }
    } else {
      throw new Error('Undefined action for the given email address');
    }
  } catch (e) {
    console.error(e);
  } finally {
    form.addEventListener('change', debounce(checkForSubscription, 300));
  }
};

// used for validating dob for yp199 & yp225 subscription offers
export const validateDOB = () => {
  const getSelectValue = (id) => {
    let value = null;
    const select = document.getElementById(id);
    if (select) {
      const option = select.options[select.selectedIndex];
      if (option && !option.disabled) {
        value = option.value;
      }
    }
    return value;
  };

  const month = getSelectValue('select-month');
  const day = getSelectValue('select-day');
  const year = getSelectValue('select-year');

  const isDobComplete = month !== null && day !== null && year !== null;

  if (!isDobComplete) {
    // if any field is empty, force disable payment section, but don't show error message
    updateShowPaymentForm(true);
  } else if (isYoungEnough(new Date(year, month, day))) {
    $('#dob-error').addClass('hidden');
    updateShowPaymentForm();
  } else {
    $('#dob-error').removeClass('hidden');
    updateShowPaymentForm();
  }
};

// checks if user is 30 yrs old or less
const isYoungEnough = (birthday) => {
  const cutoff = new Date();
  cutoff.setFullYear(cutoff.getFullYear() - 31); // Your DOB if you turn 31 today
  return birthday > cutoff; // return a boolean
};

// Magic to ensure the datepicker doesn't display dates that don't exist
export const formatDateOptions = (month) => {
  // Only show 29 days for Feb
  if (month.val() === 'February') {
    $('option[value="30"]').css('display', 'none');
    $('option[value="31"]').css('display', 'none');
    // Only show 30 days for April, June, September, November
  } else if (
    month.val() === 'April' ||
    month.val() === 'June' ||
    month.val() === 'September' ||
    month.val() === 'November'
  ) {
    $('option[value="30"]').css('display', 'block');
    $('option[value="31"]').css('display', 'none');
    // Show all days
  } else {
    $('option[value="30"]').css('display', 'block');
    $('option[value="31"]').css('display', 'block');
  }
};
